import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { EnhancedCard } from 'components/enhanced/card/EnhancedCard';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { useIsTechnicianCoordinator } from 'shared/permissions/useIsTechnicianCoordinator';
import { Location } from 'features/inventory/locations/types';
import LocationForm from 'features/settings/topology/components/LocationForm';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { locationService } from 'shared/services';
import toast from 'shared/utils/toast';
import { EnhancedDialog } from 'components/enhanced';
import { LocationColumns } from 'features/inventory/locations/locations';

interface LocationTabProps {
  warehouseId: number;
  translationPrefix: string;
}

export function LocationTab({ warehouseId, translationPrefix }: LocationTabProps) {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);

  const isDisabledEdit = useIsTechnicianCoordinator() || useIsTechnician();

  const initLocation: Location = {
    id: null,
    code: '',
    description: '',
    warehouse: `${warehouseId}`
  };

  const createLocation = async (values) => {
    const payload = {
      ...values,
      warehouse: +warehouseId
    };
    locationService.add(payload).then((res) => {
      if (res) {
        toast.success(t(`${translationPrefix}.location-created`));
      }
    });
    setOpenDialog(false);
  };

  const columns = LocationColumns();

  return (
    <>
      <EnhancedCard
        title={t('menu.locations')}
        buttons={
          <Button onClick={() => setOpenDialog(true)} variant="outlined" size="small">
            <AddIcon />
            {t(`${translationPrefix}.add-location`)}
          </Button>
        }>
        <EnhancedDataGrid
          service={locationService}
          columns={columns}
          outerParams={{ warehouse_id: `${warehouseId}` }}
          disableDelete={isDisabledEdit}
        />
      </EnhancedCard>

      <EnhancedDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        title={t(`${translationPrefix}.add-location`)}
        maxWidth="sm"
        costumFooter={<></>}>
        <LocationForm location={initLocation} onSubmit={createLocation} />
      </EnhancedDialog>
    </>
  );
}
